<script>
	import { tick } from "svelte";
	import { fly } from "svelte/transition";

	import TextInput from "./TextInput.svelte";

	export let apiURL = null;
	export let optionList = null;
	export let id = null;
	export let value = null;
	export let label = null;
	export let disabled = null;
	export let readonly = null;
	export let required = null;
	export let placeholder = null;

	let lookupResult = [];
	let timer = null;
	let firstTime = true;
	let showResult = true;
	let list = null;

	const lookUp = async (searchText) => {
		if (searchText && apiURL) {
			let url = `${apiURL}${searchText}`;

			let response = await fetch(url, {
				method: "GET",
				headers: {
					"Content-type": "application/json"
				}
			});

			if (response.ok) {
				lookupResult = await response.json();
			} else {
				lookupResult = [];
				console.log(`Error - ${response.status}`);
			}
		} else if (searchText && optionList) {
			lookupResult = optionList.filter((o) => o.value.toLowerCase().indexOf(searchText.toLowerCase()) >= 0);
		} else {
			lookupResult = [];
		}

		showResult = true;
		list.style.height = "auto";

		await tick();

		let bounding = list.getBoundingClientRect();
		let actualHheight = bounding.bottom - bounding.top;
		let heightForLookupList = window.innerHeight - list.getBoundingClientRect().y - 60 - 20;

		if (actualHheight > heightForLookupList) {
			list.style.height = `${heightForLookupList}px`;
		}
	};

	const handleFocus = () => {
		if (optionList) {
			lookupResult = optionList;
		}
	};

	const handleBlur = () => {
		showResult = false;
		lookupResult = [];
		firstTime = true;
	};

	const handleOptionMousedown = (e) => {
		const seletcedValue = e.target.dataset.value;

		value = seletcedValue;
		lookupResult = [];
		firstTime = true;
		showResult = false;
	};

	const debounce = async (searchText) => {
		clearTimeout(timer);
		timer = setTimeout(() => {
			lookUp(searchText);
		}, 500);
	};

	$: {
		firstTime || debounce(value);
		firstTime = false;
	}
</script>

<TextInput
	{id}
	{label}
	bind:value
	{required}
	{disabled}
	{readonly}
	{placeholder}
	on:focus={handleFocus}
	on:blur={handleBlur}
/>

{#if showResult && (lookupResult.length > 1 || lookupResult[0] != value)}
	<div class="wrap">
		<ul
			class="options"
			bind:this={list}
			transition:fly={{ duration: 200, y: 5 }}
			on:mousedown|preventDefault={handleOptionMousedown}
		>
			{#each lookupResult as option}
				<li data-value={option.value}>{option.label}</li>
			{/each}
		</ul>
	</div>
{/if}

<style>
	div.wrap {
		position: relative;
	}

	.options {
		box-shadow:
			0px 2px 4px rgba(0, 0, 0, 0.1),
			0px -2px 4px rgba(0, 0, 0, 0.1);
		left: 0;
		list-style: none;
		margin-block-end: 0;
		margin-block-start: 0;
		max-height: 70vh;
		overflow: auto;
		padding-inline-start: 0;
		position: absolute;
		width: 100%;
		z-index: 200;
	}
	li {
		background-color: white;
		cursor: pointer;
		padding: 2px 8px;
		border-bottom: solid 1px #efefef;
	}
	li:last-child {
		border-bottom-left-radius: 0.2rem;
		border-bottom-right-radius: 0.2rem;
		border-bottom: none;
	}
	li:not(.selected):hover {
		background-color: hsl(214, 17%, 92%);
	}
	li.selected {
		background-color: hsl(232, 54%, 41%);
		color: white;
	}
	li.selected:nth-child(even) {
		background-color: hsl(232, 50%, 45%);
		color: white;
	}
	li.active {
		background-color: hsl(214, 17%, 88%);
	}
	li.selected.active,
	li.selected:hover {
		background-color: hsl(232, 48%, 50%);
	}
</style>
